import { useEffect } from 'react';

const useFacebookFeedback = () => {
  useEffect(() => {
    if (window['FB']) {
      window['FB']['XFBML'].parse();
    }

    window['fbAsyncInit'] = () =>
      window['FB'].init({
        appId: '246321579413207',
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true, // parse social plugins on this page
        version: 'v2.7', // use version 2.1
      });
    // Load the SDK asynchronously
    ((d, s, id) => {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.setAttribute('src', '//connect.facebook.net/en_US/sdk.js');

      fjs?.parentNode?.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  });
};

export default useFacebookFeedback;
